import AddressName from "./AddressName";
import AddressLink from "./AddressLink";


import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const AddressDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Address-detail-title"
                    >
                        { label || t`Address` }: <AddressName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Address-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Address-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="address-label"><Trans>Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="address-value" >{ data.address || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="city-label"><Trans>City</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="city-value" >{ data.city || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="country-label"><Trans>Country</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="country-value" >{ data.country || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="email-label"><Trans>Email</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="email-value" >{ data.email || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="phone-label"><Trans>Phone</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="phone-value" >{ data.phone || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="mobilePhone-label"><Trans>Mobile Phone</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="mobilePhone-value" >{ data.mobilePhone || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="description-label"><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="description-value" >{ data.description || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default AddressDetail;
